/**
 * The question "Ask the assistant to explain this row" sends: the row as the grid shows it, under
 * the page title and the column titles users see. SQL column names (dTransactionDate) never go in,
 * so the answer has no reason to repeat them.
 */

/** One column of the row: its SQL name, the key into the row, and the title the grid shows. */
export interface AskRowColumn {
  name: string;
  title: string;
}

/** Longest value sent; a longer one (a blob, a long note) is left out. */
const MAX_VALUE_LENGTH = 200;

export function buildAskRowPrompt(
  pageTitle: string,
  columns: readonly AskRowColumn[],
  row: readonly unknown[],
  colIndex: Record<string, number>,
): string {
  const pairs: string[] = [];
  for (const column of columns) {
    // A column the grid shows without a title (an action or icon column) has no name to give it.
    const title = column.title.trim();
    if (!title) continue;
    const idx = colIndex[column.name];
    if (idx == null || idx < 0) continue;
    const value = row[idx];
    if (value == null || value === "") continue;
    const text = String(value);
    if (text.length > MAX_VALUE_LENGTH) continue;
    pairs.push(`${title}: ${text}`);
  }
  return `Explain this row from ${pageTitle}:\n${pairs.join("\n")}`;
}
